module.exports = __webpack_public_path__ + "img/pingpong.00690da7.jpg";